export type ListingShareMethod = 'copy' | 'qr' | 'native';
export type ListingSharePlacement = 'listing_detail' | 'owner_card' | 'listing_monitor';

export function getListingShareUrl(
  listingUrl: string,
  listingId: string | number,
  method: ListingShareMethod,
  placement: ListingSharePlacement,
  sharerRole: 'owner' | 'visitor',
) {
  const url = new URL(listingUrl);
  url.searchParams.set('utm_source', 'listing_share');
  url.searchParams.set('utm_medium', 'referral');
  url.searchParams.set('utm_campaign', 'listing_share');
  url.searchParams.set('utm_content', `${listingId}_${method}_${placement}_${sharerRole}`);
  return url.toString();
}
